import {useEffect} from 'react';

function CloudFunctionTestPage() {

  const testCF = () => {
    fetch('https://sayhello-azqtamp3wa-uc.a.run.app', {
      credentials: 'include',
      // body: JSON.stringify({text: 'Some text'}),
      // headers: {
      //     'Content-Type': 'application/json',
      // },
    })
      .then(() => {
        console.log('fetch then')
      })
  }

  useEffect(() => {
    testCF()
  }, [])

  return <>CloudFunctionTest</>
}

export default CloudFunctionTestPage
